export function checkPermission(allowedPermissions, userPermissions) {
  return allowedPermissions.some((permission) =>
    userPermissions.includes(permission)
  );
}